const messages = {
  responseError: 'Something went wrong',
  socketError: 'Something went wrong with websockets!',
  formHasErrors: 'The form has validation errors',
}

export default messages
